export function capitalize(str: string) {
    return str
        .toLocaleLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toLocaleUpperCase() + s.substring(1))
        .join(' ');
}

export function nl2br(str: string) {
    return str.replace(/\n+/g, '<br />');
}

export function limitText(str: string, limit: number) {
    if (str.length > limit) {
        return str.substr(0, limit) + '…';
    }
    return str;
}

export function pageTitle(title: string) {
    return `MediaArchiver ›› ${title}`;
}

export function sortObjectByKeys(o: Record<string, any>) {
    return Object.keys(o)
        .sort()
        .reduce((r, k) => {
            r[k] = o[k];
            return r;
        }, {});
}
